import React, { FunctionComponent, useEffect } from 'react';

import { m as motion, useAnimation } from 'framer-motion';

const Wiggler: FunctionComponent<{ doWiggle: boolean }> = ({
  doWiggle,
  children,
}) => {
  const controls = useAnimation();

  useEffect(() => {
    if (doWiggle) {
      controls.start({
        x: ['0px', '12px', '-12px', '12px', '0px'],
      });
    }
  }, [controls, doWiggle]);

  return (
    <motion.div
      initial={doWiggle}
      animate={controls}
      transition={{
        duration: 0.5,
        times: [0, 0.17, 0.5, 0.83, 1],
        ease: 'easeInOut',
      }}
    >
      {children}
    </motion.div>
  );
};

export default Wiggler;
